import { ProjectRegistryError } from "./types.js";
export const REQUIRED_ANOOPAM_PROJECT_IDS = [
    "anoopam-press-website",
    "aarpay-v2",
    "email-server",
    "pdf-intelligence-service",
    "smart-ordering",
    "smartprint-pdf-service",
    "whatsapp-saas-backend",
];
export const PROJECT_REGISTRY = [
    {
        projectId: "smart-print",
        displayName: "Smart Print Calculator",
        repository: "smartshikka/smart-print-calculator-acount",
        repositoryAliases: ["Anoojmettal/smart-print-calculator-acount"],
        visibility: "public",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-smart-print",
        databaseRef: "symbolic:smart-print-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: ["smart-print-audit", "reverse-code-audit", "reverse-supply-chain-security", "reverse-docs-generator", "reverse-diagram-generator"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "public",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "read",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "smart-ordering",
        displayName: "Smart Ordering",
        repository: "smartshikka/smart-ordering-core",
        repositoryAliases: [
            "Anoojmettal/smart-ordering-core",
            "Anoojmettal/smart-ordering",
            "smartshikka/smart-ordering",
        ],
        visibility: "private",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-smart-ordering",
        databaseRef: "symbolic:smart-ordering-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: ["smart-ordering-audit", "reverse-api-security", "reverse-code-audit", "reverse-supply-chain-security", "reverse-email-security", "reverse-database-security", "reverse-docs-generator", "reverse-diagram-generator"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "smart-salary",
        displayName: "Smart Salary",
        repository: "smartshikka/smart-salary-app",
        repositoryAliases: [
            "Anoojmettal/smart-salary-app",
            "Anoojmettal/smart-salary",
            "smartshikka/smart-salary",
        ],
        visibility: "private",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-smart-salary",
        databaseRef: "symbolic:smart-salary-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: ["smart-salary-audit", "reverse-api-security", "reverse-code-audit", "reverse-supply-chain-security", "reverse-email-security", "reverse-database-security", "reverse-docs-generator", "reverse-diagram-generator"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "drishti-kundali",
        displayName: "Drishti Kundali",
        repository: "smartshikka/drishti-kundali-matching",
        repositoryAliases: [
            "Anoojmettal/drishti-kundali-matching",
            "Anoojmettal/drishti-kundali",
            "smartshikka/drishti-kundali",
        ],
        visibility: "private",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-drishti-kundali",
        databaseRef: "symbolic:drishti-kundali-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: ["drishti-kundali-audit", "reverse-api-security", "reverse-code-audit", "reverse-supply-chain-security", "reverse-email-security", "reverse-database-security", "reverse-docs-generator", "reverse-diagram-generator"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "anoopam-press-website",
        displayName: "Anoopam Press Website",
        repository: "smartshikka/anoopam-press-website",
        repositoryAliases: ["Anoojmettal/anoopam-press-website"],
        visibility: "public",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-anoopam-press-website",
        databaseRef: "symbolic:anoopam-press-website-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: ["anoopam-website-audit", "reverse-api-security", "reverse-code-audit", "reverse-supply-chain-security", "reverse-email-security", "reverse-docs-generator", "reverse-diagram-generator"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "public",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "read",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "stylus-education",
        displayName: "Stylus Education",
        repository: "Anoojmettal/stylus-education",
        visibility: "private",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-stylus-education",
        databaseRef: "symbolic:stylus-education-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: ["stylus-study-audit"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "anshika-api",
        displayName: "Anshika API",
        repository: "smartshikka/anshika-saas-api-webhook",
        repositoryAliases: [
            "Anoojmettal/anshika-api",
            "smartshikka/anshika-api",
            "Anoojmettal/anshika-saas-api-webhook",
        ],
        visibility: "private",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-anshika-api",
        databaseRef: "symbolic:anshika-api-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: ["anshika-api-audit", "reverse-api-security", "reverse-code-audit", "reverse-supply-chain-security", "reverse-email-security", "reverse-cloud-k8s", "reverse-database-security", "reverse-docs-generator", "reverse-diagram-generator"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "anshika-website-maker",
        displayName: "Anshika Website Maker",
        repository: "smartshikka/anshika-digital-website-maker",
        repositoryAliases: [
            "Anoojmettal/anshika-website-maker",
            "smartshikka/anshika-website-maker",
            "Anoojmettal/anshika-digital-website-maker",
        ],
        visibility: "private",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-anshika-website-maker",
        databaseRef: "symbolic:anshika-website-maker-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: ["anshika-builder-audit", "reverse-api-security", "reverse-code-audit", "reverse-supply-chain-security", "reverse-email-security", "reverse-cloud-k8s", "reverse-database-security", "reverse-docs-generator", "reverse-diagram-generator"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "arcreel",
        displayName: "ArcReel",
        repository: "Anoojmettal/arcreel",
        visibility: "public",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-arcreel",
        databaseRef: "symbolic:arcreel-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: ["arcreel-public-audit"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "public",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "read",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "dify-anoopampress",
        displayName: "Dify AnoopamPress",
        repository: "Anoojmettal/dify-anoopampress",
        visibility: "private",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-dify-anoopampress",
        databaseRef: "symbolic:dify-anoopampress-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: ["dify-workflow-audit"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "aarpay-v2",
        displayName: "AarPay V2",
        repository: "smartshikka/aarpay-v2",
        repositoryAliases: ["Anoojmettal/aarpay-v2"],
        visibility: "private",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-aarpay-v2",
        databaseRef: "symbolic:aarpay-v2-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: [],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "email-server",
        displayName: "Email Server",
        repository: "smartshikka/email-server",
        repositoryAliases: ["Anoojmettal/email-server"],
        visibility: "private",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-email-server",
        databaseRef: "symbolic:email-server-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: [],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "pdf-intelligence-service",
        displayName: "PDF Intelligence Service",
        repository: "smartshikka/pdf-intelligence-service",
        repositoryAliases: ["Anoojmettal/pdf-intelligence-service"],
        visibility: "private",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-pdf-intelligence-service",
        databaseRef: "symbolic:pdf-intelligence-service-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: [],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "smartprint-pdf-service",
        displayName: "SmartPrint PDF Service",
        repository: "smartshikka/smartprint-pdf-service",
        repositoryAliases: ["Anoojmettal/smartprint-pdf-service"],
        visibility: "private",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-smartprint-pdf-service",
        databaseRef: "symbolic:smartprint-pdf-service-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: [],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "whatsapp-saas-backend",
        displayName: "WhatsApp SaaS Backend",
        repository: "smartshikka/whatsapp-saas-backend",
        repositoryAliases: ["Anoojmettal/whatsapp-saas-backend"],
        visibility: "private",
        defaultBranch: "feat/canonical-signed-transport",
        allowedBranches: ["feat/canonical-signed-transport", "main"],
        knowledgeLibraryId: "kl-whatsapp-saas-backend",
        databaseRef: "symbolic:whatsapp-saas-backend-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: [],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
    {
        projectId: "smart-shikka-core",
        displayName: "Smart Shikka Core",
        repository: "smartshikka/smart-shikka-core",
        repositoryAliases: ["Anoojmettal/smart-shikka-core"],
        visibility: "private",
        defaultBranch: "main",
        allowedBranches: ["main"],
        knowledgeLibraryId: "kl-smart-shikka-core",
        databaseRef: "symbolic:smart-shikka-core-db",
        mcpConnections: ["general-mcp"],
        allowedSkills: [],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        readPolicy: "tenant",
        writePolicy: "approval",
        approvalPolicy: "owner",
        auditPolicy: "all",
        ownerIds: ["owner-anooj"],
        tenantIds: ["tenant-anoopam"],
        emergencyStopScope: "project",
        status: "active",
    },
];
/**
 * CWJ-04 — deterministic registry version hash.
 * Pure-JS (no crypto), works in browser and Node. Recomputed on every call so
 * persisted snapshots can detect registry drift and be invalidated safely.
 */
function djb2Hash(input) {
    let hash = 5381;
    for (let i = 0; i < input.length; i++) {
        hash = (hash * 33) ^ input.charCodeAt(i);
    }
    return (hash >>> 0).toString(16);
}
export function getProjectRegistryVersion() {
    return djb2Hash(JSON.stringify(PROJECT_REGISTRY));
}
export function getProjectById(projectId) {
    return PROJECT_REGISTRY.find((p) => p.projectId === projectId);
}
export function listProjectIds() {
    return PROJECT_REGISTRY.map((p) => p.projectId);
}
export function listProjects() {
    return PROJECT_REGISTRY;
}
const REPOSITORY_FORMAT = /^[A-Za-z0-9_.-]+\/[A-Za-z0-9_.-]+$/;
const MAX_REPOSITORY_LENGTH = 255;
function isString(value) {
    return typeof value === "string";
}
function getTrimmedString(value) {
    return isString(value) ? value.trim() : "";
}
function isStringArray(value) {
    return Array.isArray(value) && value.every((item) => typeof item === "string");
}
function isNonEmptyStringArray(value) {
    return isStringArray(value) && value.length > 0;
}
/**
 * Lowercased `owner/repo` canonical form. Malformed input (not exactly two
 * non-empty segments) is returned unchanged so callers can compare it without
 * throwing — it will never equal a registered canonical repository. Shape
 * validation itself belongs to callers (REPOSITORY_FORMAT at write time).
 */
export function getCanonicalRepository(repository) {
    const parts = repository.split("/");
    if (parts.length !== 2 || parts[0].trim() === "" || parts[1].trim() === "") {
        return repository;
    }
    return `${parts[0].trim().toLowerCase()}/${parts[1].trim().toLowerCase()}`;
}
function allRepositoryRefs(project) {
    return [project.repository, ...(project.repositoryAliases ?? [])];
}
/**
 * Resolve any known repository reference (canonical or legacy alias) to the
 * canonical `owner/repo` string of the owning project. Returns undefined for
 * unknown repositories.
 */
export function resolveCanonicalRepository(repository) {
    if (!isString(repository))
        return undefined;
    const canonical = getCanonicalRepository(repository);
    for (const project of PROJECT_REGISTRY) {
        for (const ref of allRepositoryRefs(project)) {
            if (getCanonicalRepository(ref) === canonical) {
                return getCanonicalRepository(project.repository);
            }
        }
    }
    return undefined;
}
/** Lookup a project by canonical repository or any registered legacy alias. */
export function getProjectByRepository(repository) {
    const canonical = resolveCanonicalRepository(repository);
    if (canonical === undefined)
        return undefined;
    return PROJECT_REGISTRY.find((p) => getCanonicalRepository(p.repository) === canonical);
}
export function isSafeGitRef(value) {
    if (!isString(value))
        return false;
    if (value.length === 0)
        return false;
    if (value.startsWith("-"))
        return false;
    if (value.endsWith("."))
        return false;
    if (value.includes(".."))
        return false;
    if (value.startsWith("/") || value.endsWith("/"))
        return false;
    if (value.includes("//"))
        return false;
    if (/[^A-Za-z0-9_.\-/]/.test(value))
        return false;
    const components = value.split("/");
    for (const component of components) {
        if (component.length === 0)
            return false;
        if (component.startsWith("."))
            return false;
        if (component.endsWith(".lock"))
            return false;
    }
    return true;
}
export function validateProjectRegistry(entries = PROJECT_REGISTRY, requiredProjectIds = []) {
    const errors = [];
    const ids = new Set();
    const repositories = new Set();
    if (!Array.isArray(entries)) {
        return { valid: false, errors: ["entries must be an array"] };
    }
    if (!Array.isArray(requiredProjectIds)) {
        errors.push("requiredProjectIds must be an array");
    }
    for (let index = 0; index < entries.length; index++) {
        const project = entries[index];
        if (project === null || typeof project !== "object" || Array.isArray(project)) {
            errors.push(`Entry ${index} is not a valid project object`);
            continue;
        }
        const raw = project;
        const projectId = getTrimmedString(raw.projectId);
        const displayName = getTrimmedString(raw.displayName);
        const repositoryRaw = getTrimmedString(raw.repository);
        const defaultBranch = getTrimmedString(raw.defaultBranch);
        const knowledgeLibraryId = getTrimmedString(raw.knowledgeLibraryId);
        const databaseRef = getTrimmedString(raw.databaseRef);
        const label = projectId || "(unknown)";
        if (ids.has(projectId)) {
            errors.push(`Duplicate projectId: ${projectId}`);
        }
        ids.add(projectId);
        if (projectId === "") {
            errors.push(`Project ${label}: projectId must be a non-empty string`);
        }
        if (displayName === "") {
            errors.push(`Project ${label}: displayName must be a non-empty string`);
        }
        if (!isString(raw.repository) || repositoryRaw === "") {
            errors.push(`Project ${label}: repository must be a non-empty string`);
        }
        else if (repositoryRaw.length > MAX_REPOSITORY_LENGTH ||
            !REPOSITORY_FORMAT.test(repositoryRaw) ||
            repositoryRaw.includes("..") ||
            repositoryRaw.includes(":") ||
            repositoryRaw.startsWith("/")) {
            errors.push(`Project ${label}: repository must be a canonical owner/repo reference`);
        }
        else {
            const canonicalRepo = getCanonicalRepository(repositoryRaw);
            if (repositories.has(canonicalRepo)) {
                errors.push(`Project ${label}: duplicate repository`);
            }
            repositories.add(canonicalRepo);
        }
        if (raw.repositoryAliases !== undefined) {
            if (!isStringArray(raw.repositoryAliases)) {
                errors.push(`Project ${label}: repositoryAliases must be an array of strings`);
            }
            else {
                for (const alias of raw.repositoryAliases) {
                    const trimmedAlias = getTrimmedString(alias);
                    if (trimmedAlias === "" ||
                        trimmedAlias.length > MAX_REPOSITORY_LENGTH ||
                        !REPOSITORY_FORMAT.test(trimmedAlias) ||
                        trimmedAlias.includes("..") ||
                        trimmedAlias.includes(":") ||
                        trimmedAlias.startsWith("/")) {
                        errors.push(`Project ${label}: repositoryAliases must contain canonical owner/repo references`);
                        break;
                    }
                    const canonicalAlias = getCanonicalRepository(trimmedAlias);
                    if (canonicalAlias === getCanonicalRepository(repositoryRaw)) {
                        errors.push(`Project ${label}: repositoryAliases must not repeat the canonical repository`);
                        break;
                    }
                    if (repositories.has(canonicalAlias)) {
                        errors.push(`Project ${label}: repositoryAliases collides with another repository or alias`);
                        break;
                    }
                    repositories.add(canonicalAlias);
                }
            }
        }
        if (!isString(raw.defaultBranch) || defaultBranch === "") {
            errors.push(`Project ${label}: defaultBranch must be a non-empty string`);
        }
        else if (!isSafeGitRef(defaultBranch)) {
            errors.push(`Project ${label}: defaultBranch must be a safe Git ref name`);
        }
        if (!isNonEmptyStringArray(raw.allowedBranches)) {
            errors.push(`Project ${label}: allowedBranches must be a non-empty array of strings`);
        }
        else {
            for (const branch of raw.allowedBranches) {
                if (!isSafeGitRef(branch)) {
                    errors.push(`Project ${label}: allowedBranches contains unsafe Git ref name`);
                    break;
                }
            }
        }
        if (!isString(raw.knowledgeLibraryId) || knowledgeLibraryId === "") {
            errors.push(`Project ${label}: knowledgeLibraryId must be a non-empty string`);
        }
        if (!isString(raw.databaseRef) || databaseRef === "") {
            errors.push(`Project ${label}: databaseRef must be a non-empty string`);
        }
        else if (databaseRef.includes("://") && databaseRef.includes("@")) {
            errors.push(`Project ${label}: databaseRef must be symbolic, not a real connection string`);
        }
        if (!isStringArray(raw.mcpConnections) || raw.mcpConnections.length === 0) {
            errors.push(`Project ${label}: mcpConnections must be a non-empty array of strings`);
        }
        if (!isStringArray(raw.allowedSkills)) {
            errors.push(`Project ${label}: allowedSkills must be an array of strings`);
        }
        if (!isNonEmptyStringArray(raw.allowedTools)) {
            errors.push(`Project ${label}: allowedTools must be a non-empty array of strings`);
        }
        if (!isNonEmptyStringArray(raw.ownerIds)) {
            errors.push(`Project ${label}: ownerIds must be a non-empty array of strings`);
        }
        if (!isNonEmptyStringArray(raw.tenantIds)) {
            errors.push(`Project ${label}: tenantIds must be a non-empty array of strings`);
        }
        const visibilityValues = ["public", "private", "internal"];
        if (!isString(raw.visibility) || !visibilityValues.includes(raw.visibility)) {
            errors.push(`Project ${label}: visibility must be one of public, private, internal`);
        }
        const statusValues = ["active", "disabled", "archived"];
        if (!isString(raw.status) || !statusValues.includes(raw.status)) {
            errors.push(`Project ${label}: status must be one of active, disabled, archived`);
        }
        const writePolicy = isString(raw.writePolicy) ? raw.writePolicy : "";
        if (isString(raw.visibility) &&
            raw.visibility === "public" &&
            writePolicy !== "approval" &&
            writePolicy !== "owner") {
            errors.push(`Project ${label}: public project writePolicy must be approval or owner`);
        }
    }
    if (Array.isArray(requiredProjectIds) && requiredProjectIds.length > 0) {
        const presentIds = new Set(ids);
        for (const requiredId of requiredProjectIds) {
            if (!presentIds.has(requiredId)) {
                errors.push(`Required project ${requiredId} is missing from registry`);
            }
        }
    }
    return { valid: errors.length === 0, errors };
}
export function canReadProject(project, tenantId, ownerId) {
    if (project.status !== "active")
        return false;
    if (project.readPolicy === "public")
        return true;
    if (ownerId && project.ownerIds.includes(ownerId))
        return true;
    if (tenantId && project.tenantIds.includes(tenantId))
        return true;
    return project.readPolicy === "authenticated" && (ownerId !== undefined || tenantId !== undefined);
}
export function canWriteProject(project, tenantId, ownerId) {
    if (project.status !== "active")
        return false;
    if (ownerId && project.ownerIds.includes(ownerId))
        return true;
    if (tenantId && project.tenantIds.includes(tenantId) && project.writePolicy === "tenant")
        return true;
    return false;
}
export function assertProjectAllowed(projectId, tenantId, ownerId, operation = "read") {
    const project = getProjectById(projectId);
    if (!project) {
        throw new ProjectRegistryError(`Unknown project: ${projectId}`, "unknown_project");
    }
    if (project.status !== "active") {
        throw new ProjectRegistryError(`Project ${projectId} is disabled`, "disabled_project");
    }
    const allowed = operation === "write" ? canWriteProject(project, tenantId, ownerId) : canReadProject(project, tenantId, ownerId);
    if (!allowed) {
        throw new ProjectRegistryError(`Project ${projectId} not allowed for ${operation}: wrong owner, tenant, or insufficient read policy`, "unauthorized");
    }
    return project;
}
export function redactProjectForExport(project) {
    return {
        projectId: project.projectId,
        displayName: project.displayName,
        repository: project.repository,
        ...(project.repositoryAliases !== undefined
            ? { repositoryAliases: project.repositoryAliases }
            : {}),
        visibility: project.visibility,
        defaultBranch: project.defaultBranch,
        allowedBranches: project.allowedBranches,
        knowledgeLibraryId: project.knowledgeLibraryId,
        mcpConnections: project.mcpConnections,
        allowedSkills: project.allowedSkills,
        allowedTools: project.allowedTools,
        readPolicy: project.readPolicy,
        writePolicy: project.writePolicy,
        approvalPolicy: project.approvalPolicy,
        auditPolicy: project.auditPolicy,
        emergencyStopScope: project.emergencyStopScope,
        status: project.status,
    };
}
//# sourceMappingURL=projectRegistry.js.map